import { Trans } from '@lingui/react/macro';

import Paragraph from '@/design_system/Typography/Paragraph';
import { RequestWithRelations } from '@/models/request';
import { useShipments } from '@/models/shipment';
import { MobileShipmentsList } from '@/routes/Shipments/Tabs/components/MobileShipmentsList';
import { ShipmentsTable } from '@/routes/Shipments/Tabs/components/ShipmentsTable';
import useViewPort from '@/utils/useViewport';

const ShipmentsTableForRequest = ({ request }: { request: RequestWithRelations }) => {
  const { isMobile } = useViewPort();
  const { data: { shipments } = { shipments: [] }, isLoading } = useShipments({
    requestId: request.id,
  });

  return (
    <>
      {!isLoading && shipments.length === 0 && (
        <Paragraph
          size="200"
          color="secondary"
          style={{
            paddingTop: isMobile ? '0.5rem' : undefined,
            padding: isMobile ? undefined : '1rem',
          }}
        >
          <Trans id="request.related-shipments.none">No deliveries associated yet</Trans>
        </Paragraph>
      )}
      {!isLoading && shipments.length > 0 && (
        <>
          {isMobile ? (
            <MobileShipmentsList shipments={shipments ?? []} />
          ) : (
            <ShipmentsTable shipments={shipments ?? []} />
          )}
        </>
      )}
    </>
  );
};

export default ShipmentsTableForRequest;
